"use client";

import { Stack, Box, useToast, Badge, Spinner } from "@chakra-ui/react";
import InputMask from "react-input-mask";
import { OnboardingLayout } from "../layout/OnboardingLayout";
import { CustomInput, CustumSelect } from "../components/Input";
import { CustomButton } from "../components/Buttons";
import FileInput from "../components/FIleInput";
import UploadCareWidget from "../components/UploadCareWidget";
import { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { API_BASE_URL } from "../components/APIs";
import axios from "axios";
import { useApiData } from "../components/GetData";
import { LoadingSpinner } from "../components/LoadingSpinner";
import SubmitApplication from "./SubmitApplication";
import FileUpload from "../components/FileUpload";
import PdfViewer from "../components/PDFViewer";
import Cookies from "js-cookie";
import FormNavigation from "../components/FormNavigation";
import { useNavigate } from "react-router-dom";

export default function RTWUpload() {
  const {
    data: userRTW,
    loading,
    fetchData,
  } = useApiData("application/getUserRTW");
  useEffect(() => {
    fetchData();
  }, []);
  const navigate = useNavigate();

  const uid = Cookies.get("uid");
  const toast = useToast();
  const [isLoading, setLoading] = useState();
  const [pdfFile, setpdfFile] = useState();

  // Check if UK Passport is selected
  // const isUKPassport = formik.values.visa_type === "UK Passport";

  const formik = useFormik({
    initialValues: {
      update: "create",
      visa_type: "",
      visa_number: "",
      visa_issue_date: "",
      visa_expiry_date: "",
      visa_file: "",
      share_code: "",
      nin: '',
      dob: "",
      user_id: uid,
    },
    validationSchema: Yup.object({
      visa_type: Yup.string().required("This field is required"),
      // Conditional validation based on visa type
      visa_number: Yup.string().when('visa_type', {
        is: (visa_type) => visa_type === "UK Passport",
        then: (schema) => schema.required("Document number is required for UK Passport"),
        otherwise: (schema) => schema.notRequired()
      }),
      nin: Yup.string().required("National Insurance Number is required"),
      visa_issue_date: Yup.string().required("This field is required"),
      visa_expiry_date: Yup.string().required("This field is required"),
      visa_file: Yup.string().required("Document upload is required"),
      // Share code required for non-UK Passport visas
      share_code: Yup.string().when('visa_type', {
        is: (visa_type) => visa_type && visa_type !== "UK Passport",
        then: (schema) => schema.required("Share code is required for this visa type"),
        otherwise: (schema) => schema.notRequired()
      }),
    }),
    onSubmit: (data) => {
      setLoading(true);
      const url = API_BASE_URL + "application/saveRTW";
      axios
        .post(url, data)
        .then((response) => {
          if (response.data.status === 200) {
            toast({
              title: "Profile Update",
              description: response.data.message,
              position: "top",
              status: "success",
              isClosable: true,
            });
            setLoading(false);
          } else {
            toast({
              title: "Profile Update Error",
              description: response.data.message,
              position: "top",
              status: "error",
              isClosable: true,
            });
            setLoading(false);
          }
        })
        .catch((error) => {
          toast({
            title: "error",
            description: error.message,
            position: "top",
            status: "error",
            isClosable: true,
          });
          setLoading(false);
        });
    },
  });

  const visa_types = [
    { value: "UK Passport", label: "UK Passport" },
    { value: "Student VISA", label: "Student VISA" },
    { value: "Work VISA", label: "Work VISA" },
    { value: "Dependent VISA", label: "Dependent VISA" },
    { value: "Indefinite Leave to Remain", label: "Indefinite Leave to Remain" },
  ];

  // Update isUKPassport based on current form value
  const isUKPassport = formik.values.visa_type === "UK Passport";

  useEffect(() => {
    if (userRTW) {
      setpdfFile(API_BASE_URL + "uploads/" + userRTW.visa_file || null);
      formik.setValues({
        visa_type: userRTW.visa_type || "",
        visa_number: userRTW.visa_number || "",
        visa_expiry_date: userRTW.visa_expiry_date || "",
        visa_issue_date: userRTW.visa_issue_date || "",
        user_id: userRTW.user_id || "",
        nin: userRTW.nin || "",
        share_code: userRTW.share_code || "",
        update: "create"
      });
    }
    setLoading(false);
  }, [userRTW]);

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <OnboardingLayout
      pageTitle="RIGHT TO WORK"
      description="We need to confirm you're eligible to work in the UK so we'll use your following details to perform a right to work check."
      mainContent={
        <Stack
          direction={{ base: "column", md: "column", sm: "row" }}
          as={"form"}
          onSubmit={formik.handleSubmit}
        >
          {/* Visa Type Selection */}
          <Stack gap={4} direction={["column", "row"]}>
            <CustumSelect
              value={formik.values.visa_type}
              isInvalid={formik.errors.visa_type && formik.touched.visa_type}
              onChange={formik.handleChange}
              name="visa_type"
              placeholder="Select your visa type"
              formLabel="Visa Type"
              options={visa_types}
              label={visa_types.label}
            />
            {isUKPassport && (

              <CustomInput
                value={formik.values.visa_number}
                isInvalid={formik.errors.visa_number && formik.touched.visa_number}
                onChange={formik.handleChange}
                formLabel="Passport Number"
                type="text"
                placeholder="Enter your passport number"
                name="visa_number"
                isRequired={true}
              />

            )}
          </Stack>

          {/* Document Number - Required for UK Passport */}
          <Stack gap={4} direction={["column", "row"]}>
            {/* National Insurance Number - Always Required */}
            {!isUKPassport && formik.values.visa_type && (
              <CustomInput
                as={InputMask}
                mask="***-***-***"
                value={formik.values.share_code}
                isInvalid={formik.errors.share_code && formik.touched.share_code}
                onChange={formik.handleChange}
                formLabel="Share Code"
                type="text"
                placeholder="XXX-XXX-XXX"
                name="share_code"
                isRequired={true}
                helperText="Please provide your right to work share code"
              />


            )}
            {/* Share Code - Required for non-UK Passport visas */}
            <CustomInput
              as={InputMask}
              mask="**-**-**-**-*"
              value={formik.values.nin}
              isInvalid={formik.errors.nin && formik.touched.nin}
              onChange={formik.handleChange}
              formLabel="National Insurance Number"
              type="text"
              placeholder="AB-12-34-56-C"
              name="nin"
              isRequired={true}
            />
          </Stack>





          {/* Visa Dates - Always Required */}
          <Stack gap={2} direction={["column", "row"]}>
            <CustomInput
              value={formik.values.visa_issue_date}
              isInvalid={formik.errors.visa_issue_date && formik.touched.visa_issue_date}
              onChange={formik.handleChange}
              formLabel={isUKPassport ? "Passport Issue Date" : "Visa Issue Date"}
              type="date"
              placeholder={isUKPassport ? "Passport Issue Date" : "Visa Issue Date"}
              name="visa_issue_date"
              isRequired={true}
            />
            <CustomInput
              value={formik.values.visa_expiry_date}
              isInvalid={formik.errors.visa_expiry_date && formik.touched.visa_expiry_date}
              onChange={formik.handleChange}
              formLabel={isUKPassport ? "Passport Expiry Date" : "Visa Expiry Date"}
              type="date"
              placeholder={isUKPassport ? "Passport Expiry Date" : "Visa Expiry Date"}
              name="visa_expiry_date"
              isRequired={true}
            />
          </Stack>

          {/* File Upload - Always Required */}
          <Stack gap={2} direction={["column", "row"]}>
            <FileUpload
              onFileUpload={(file) => formik.setFieldValue("visa_file", file)}
              isRequired={true}
              helperText={isUKPassport ? "Upload your passport photo page" : "Upload your visa document"}
            />
            {formik.errors.visa_file && formik.touched.visa_file && (
              <Box color="red.500" fontSize="sm" mt={1}>
                {formik.errors.visa_file}
              </Box>
            )}
          </Stack>

          {/* PDF Viewer for existing file */}
          <Stack gap={2} direction={["column", "column"]}>
            {pdfFile && <PdfViewer pdfUrl={pdfFile} />}

            {/* Form Navigation */}
            <Box py={5} gap={5} display={'flex'} flexDir={'row'}>
              <FormNavigation
                formik={formik}
                isLoading={isLoading}
                setIsLoading={setLoading}
                nextRoute="/application/next-of-kin"
                previousRoute={'/application/id-upload'}
                progressKey="rtw"
              />
            </Box>
          </Stack>

          {/* Information Box */}
          <Box
            bg="blue.50"
            p={4}
            borderRadius="md"
            borderLeft="4px solid"
            borderColor="blue.400"
          >
            <Box fontSize="sm" color="blue.800">
              <strong>Note:</strong>
              {isUKPassport
                ? " For UK Passport holders, please provide your passport number and upload a copy of your passport photo page."
                : " For visa holders, please provide your share code and upload a copy of your visa document."
              }
            </Box>
          </Box>
        </Stack>
      }
    />
  );
}